export const TaskType = {
  GET_MY_ASSIGNED_TASKS: "GET_MY_ASSIGNED_TASKS",
  SET_MY_ASSIGNED_TASKS: "SET_MY_ASSIGNED_TASKS",
  UPDATE_TASK_STATUS: "UPDATE_TASK_STATUS",
  SET_TASK_LOADING: "SET_TASK_LOADING",
};

export const getMyAssignedTasks = () => ({
  type: TaskType.GET_MY_ASSIGNED_TASKS,
});

export const setMyAssignedTasks = (data) => ({
  type: TaskType.SET_MY_ASSIGNED_TASKS,
  payload: data,
});

export const updateTaskStatus = (taskId, statusData) => ({
  type: TaskType.UPDATE_TASK_STATUS,
  payload: { taskId, statusData },
});

export const setTaskLoading = (loading) => ({
  type: TaskType.SET_TASK_LOADING,
  payload: loading,
});
